import { render, staticRenderFns } from "./CommentEdit.vue?vue&type=template&id=607435ec&"
import script from "./CommentEdit.vue?vue&type=script&lang=js&"
export * from "./CommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports